export const GREEN = "#52d3a9"
export const BLUE = "#000f5c"
